import Card from 'antd/lib/card';
import Segmented from 'antd/lib/segmented';
import { MemoizedSitesMap } from './components/SitesMap/SitesMap';
import { useFetchMapLocations } from './useFetchMapLocations';
import { useCompanies } from 'src/components/selectors/GlobalCompanySelector/CompanyContext';
import { PRICE_TYPE_TEXT_MAP, PriceType } from 'src/domain/price-response/interface';
import { usePageLocation } from '../usePageState';
import { useLocation } from 'react-router-dom';
import { SitesMapProvider } from './components/SitesMap/SitesMapProvider';
import { useSiteMapStore } from './components/SitesMap/useSiteMapStore';
import { useEffect } from 'react';
import { MapLoading } from './components/SitesMap/MapLoading';
import Space from 'antd/lib/space';

export const SitesMapWidget = () => {
    return (
        <SitesMapProvider>
            <SitesMapWidgetContent />
        </SitesMapProvider>
    );
};

const SitesMapWidgetContent = () => {
    const priceTypeValue = useSiteMapStore(state => state.priceTypeValue);
    const setPriceTypeValue = useSiteMapStore(state => state.setPriceTypeValue);
    const mapLocation = useSiteMapStore(state => state.mapLocation);

    const urlLocation = useLocation();
    const { setPageQuery, queryToState } = usePageLocation();
    const pageState: any = queryToState(urlLocation.search);

    const { companyId } = useCompanies()!;
    const { locations, isLoading } = useFetchMapLocations(companyId);

    useEffect(() => {
        setPageQuery({ ...pageState, location: mapLocation });
    }, [mapLocation]);

    return (
        <Card
            title={
                <Space direction="horizontal" align="center" size={'large'}>
                    <>Sites</>
                    <MapLoading />
                </Space>
            }
            loading={isLoading}
            extra={
                <Segmented
                    value={priceTypeValue}
                    options={[
                        { label: PRICE_TYPE_TEXT_MAP[PriceType.REAL_TIME], value: PriceType.REAL_TIME },
                        { label: PRICE_TYPE_TEXT_MAP[PriceType.DAY_AHEAD], value: PriceType.DAY_AHEAD },
                    ]}
                    onChange={value => setPriceTypeValue(value)}
                />
            }
        >
            {isLoading !== true && <MemoizedSitesMap siteLocations={locations} />}
        </Card>
    );
};
